import React from "react";

const SelectQuestion = ({ question, value = 0, onChange }) => {
    return (
        <div className="question select-question mx-0 row align-items-center">
            <div className="chat-label col-lg-5">
                {question.label}
            </div>
            <div className="chat-answer text-center user position-relative col-lg-7 px-0">
                <select
                    className="form-select"
                    value={value}
                    onChange={(e) => onChange(Number(e.target.value))}
                >
                    <option value="">Selecione uma opção</option>
                    {question.answers.map((option, index) => {
                        const realValue = option.value ?? option.ans_id;
                        return (
                            <option key={index} value={realValue}>
                                {option.label}
                            </option>
                        );
                    })}
                </select>
            </div>
        </div>
    );
};

export default SelectQuestion;
